<div class="profile-bg-section">
    <div class="profile-section">
        <div class="profile-heading-section">
            <span>Know Your Client</span>
            <span class="profile-close-icon" (click)="close()">&times;</span>
        </div>
        <div class="profile-content-section">
            <ng-container *ngIf="profile_data_loaded">
                <div class="profile-basic-info-section">
                    <div>
                        <div class="profile-image-section">
                            <img [src]="profile_data.profile_image" onerror="this.src='assets/user-profile.png'" class="profile-image" />
                        </div>
                        <div class="profile-meta-data-section">
                            <p class="profile-name">{{profile_data.first_name}} {{profile_data.last_name}}</p>
                            <div class="profile-status-section">
                                <span class="profile-status-active-tag" *ngIf="profile_data.status == 'Active'">Active</span>
                                <span class="profile-status-inactive-tag" *ngIf="profile_data.status != 'Active'">In-Active</span>
                            </div>
                            <div class="profile-social-section">
                                <img src="assets/ic-linkedin.png" class="each-profile-social-image" (click)="navigateToExternalLink(profile_data.linkedin_url)" />
                                <img src="assets/ic-twitter.png" class="each-profile-social-image" (click)="navigateToExternalLink(profile_data.twitter_url)" />
                                <img src="assets/ic-facebook.png" class="each-profile-social-image" (click)="navigateToExternalLink(profile_data.facebook_url)" />
                            </div>
                            <span class="profile-member-section">Member Since: {{profile_data.member_since | date: "dd MMM yyyy"}}</span>
                        </div>
                    </div>
                    <div class="profile-recommendation-section">
                        <div class="each-profile-recommendation-section">
                            <span class="each-profile-recommendation-label">Growth opportunity </span>
                            <span class="each-profile-recommendation-yes" *ngIf="profile_data.growth_opportunity">Yes</span>
                            <span class="each-profile-recommendation-no" *ngIf="!profile_data.growth_opportunity">No</span>
                        </div>
                        <div class="each-profile-recommendation-section">
                            <span class="each-profile-recommendation-label">Client engagement </span>
                            <span class="each-profile-recommendation-yes" *ngIf="profile_data.client_engagement">Yes</span>
                            <span class="each-profile-recommendation-no" *ngIf="!profile_data.client_engagement">No</span>
                        </div>
                        <div class="each-profile-recommendation-section">
                            <span class="each-profile-recommendation-label">Risk </span>
                            <span class="each-profile-recommendation-yes" *ngIf="profile_data.risk">Yes</span>
                            <span class="each-profile-recommendation-no" *ngIf="!profile_data.risk">No</span>
                        </div>
                    </div>
                </div>
                <div class="profile-tabs-section">
                    <div class="each-profile-tab" *ngFor="let profile_tab of profile_tabs" [ngClass]="{'each-profile-tab-selcted': profile_tab_selected == profile_tab.name}" (click)="changeTab(profile_tab)">
                        <span>{{profile_tab.name}}</span>
                    </div>
                </div>
                <ng-container *ngIf="profile_tab_selected == profile_tabs[0].name">
                    <div class="profile-details-section" *ngFor="let profile_section of profile_fields_data">
                        <div class="profile-details-heading-section">
                            <span>{{profile_section.name}}</span>
                        </div>
                        <div class="profile-details-content-section">
                            <div class="each-profile-details-section" *ngFor="let profile_field of profile_section.fields">
                                <p class="each-profile-details-label">{{profile_field.name}}</p>
                                <p class="each-profile-details-value">{{getValue(profile_field, profile_field.key)}}</p>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngIf="profile_tab_selected == profile_tabs[1].name">
                    <div class="profile-products-section" *ngIf="profile_data.existing_products.length > 0">
                        <div class="each-profile-product-section each-profile-product-inactive" *ngFor="let existing_product of profile_data.existing_products" [ngClass]="{'each-profile-product-active': existing_product.client_product_status_name == 'Active'}">
                            <div class="each-profile-product-heading-section">
                                <span>{{existing_product.product_name}}</span>
                                <span class="each-profile-product-inactive-tag" [ngClass]="{'each-profile-product-active-tag': existing_product.client_product_status_name == 'Active'}">{{existing_product.client_product_status_name}}</span>
                            </div>
                            <div class="each-profile-product-details-section">
                                <div class="each-profile-product-aum-section">
                                    <p class="each-profile-product-aum-label">Assets Under Management({{APP_CONSTANTS.CURRENCY_SYMBOL}})</p>
                                    <p class="each-profile-product-aum-value">{{existing_product.amount}}</p>
                                </div>
                                <div class="each-product-detail-section">
                                    <span class="each-product-detail-label">Policy Number</span>
                                    <span class="each-product-detail-value">{{existing_product.policy_number}}</span>
                                </div>
                                <div class="each-product-detail-section">
                                    <span class="each-product-detail-label">Tenure(Years)</span>
                                    <span class="each-product-detail-value">{{existing_product.age}}</span>
                                </div>
                                <div class="each-product-detail-section">
                                    <span class="each-product-detail-label">Start Date</span>
                                    <span class="each-product-detail-value" *ngIf="existing_product.start_date != '' && existing_product.start_date != null">{{ existing_product.start_date | date: "dd MMM yyyy" }}</span>
                                    <span class="each-product-detail-value" *ngIf="existing_product.start_date == '' || existing_product.start_date == null" >-</span>
                                </div>
                                <div class="each-product-detail-section">
                                    <span class="each-product-detail-label">Maturity Date</span>
                                    <span class="each-product-detail-value" *ngIf="existing_product.maturity_date != '' && existing_product.maturity_date != null">{{ existing_product.maturity_date | date: "dd MMM yyyy" }}</span>
                                    <span class="each-product-detail-value" *ngIf="existing_product.maturity_date == '' || existing_product.maturity_date == null" >-</span>
                                </div>
                            </div>
                            <div class="each-profile-product-sub-details-section">
                                <div class="each-product-detail-section">
                                    <span class="each-product-detail-label">Product Type</span>
                                    <span class="each-product-detail-value">{{existing_product.product_type}}</span>
                                </div>
                                <div class="each-product-detail-section">
                                    <span class="each-product-detail-label">Sale Type</span>
                                    <span class="each-product-detail-value">{{existing_product.type}}</span>
                                </div>
                                <div class="each-product-detail-section">
                                    <span class="each-product-detail-label">Financial Institution</span>
                                    <span class="each-product-detail-value">{{existing_product.financial_institution}}</span>
                                </div>
                                <div class="each-product-detail-section">
                                    <span class="each-product-detail-label">Sold by</span>
                                    <span class="each-product-detail-value">{{existing_product.sold_by}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ng-container *ngIf="profile_data.existing_products.length == 0">
                        <div class="each-product-zero-section">
                            <span class="each-profile-product-aum-value">No Data Found</span>
                        </div>
                    </ng-container>
                </ng-container>

                <ng-container *ngIf="client_type == 'Client'">

                    <ng-container *ngIf="profile_tab_selected == profile_tabs[2].name">
                        <ng-container *ngIf="profile_data.growth_opportunity">
                            <div class="profile-products-section" *ngFor="let opp of profile_data.upside_opp">
                                <div class="each-profile-product-section each-profile-product-active">
                                    <div class="each-profile-product-heading-section">
                                        <span>Growth Opportunity</span>
                                    </div>
                                    <div class="each-profile-product-details-section">
                                        <div class="each-profile-product-aum-section">
                                            <p class="each-profile-product-aum-label">Predicted Opportunity Value({{APP_CONSTANTS.CURRENCY_SYMBOL}})</p>
                                            <p class="each-profile-product-aum-value">{{opp.predicted_opportunity}}</p>
                                        </div>
                                        <div class="each-profile-product-aum-section">
                                            <p class="each-profile-product-aum-label">Predicted Closure Days</p>
                                            <p class="each-profile-product-aum-value">{{opp.predicted_closure_days}}</p>
                                        </div>
                                    </div>
                                    <div class="each-profile-product-sub-details-section">
                                        <div class="each-product-detail-section">
                                            <span class="each-product-detail-label">Trigger Type</span>
                                            <span class="each-product-detail-value">{{opp.trigger_type}}</span>
                                        </div>
                                        <div class="each-product-detail-section">
                                            <span class="each-product-detail-label">Trigger</span>
                                            <span class="each-product-detail-value">{{opp.trigger}}</span>
                                        </div>
                                        <div class="each-product-detail-section">
                                            <span class="each-product-detail-label">Condition</span>
                                            <span class="each-product-detail-value">{{opp.reason}}</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="profile-opp-reco-section">
                                    <div class="profile-opp-stages-section">
                                        <p class="profile-opp-stages-heading">Sales Process</p>
                                        <div class="each-profile-opp-stage" *ngFor="let stage of opp.stages" [ngClass]="{'each-profile-opp-stage-selected': stage.line}">
                                            <div class="each-profile-opp-stage-details-section">
                                                <div class="each-profile-opp-circle-section" [ngClass]="{'each-profile-opp-circle-selected': stage.is_completed}"></div>
                                                <span class="each-profile-opp-circle-name">{{stage.name}}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="profile-opp-section">
                                        <!-- <div class="profile-opp-recomendation-section">
                                            <p class="profile-opp-recomendation-heading">Recommended Products</p>
                                            <p class="profile-opp-stages-heading">Recommended Products</p>
                                            <p class="profile-opp-recomendation-value" *ngFor="let recommended_product of opp.recommended_products">&#x2022; {{recommended_product}}</p>
                                        </div> -->

                                        <div class="profile-opp-recomendation-section">
                                            <!-- <p class="profile-opp-recomendation-heading">Preferred channels</p> -->
                                            <p class="profile-opp-stages-heading">Preferred channels</p>
                                            <div class="each-profile-channel-section">
                                                <img [src]="preffered_channel.image_link" class="each-profile-channel-image" *ngFor="let preffered_channel of opp.preferred_channel" [matTooltip]="preffered_channel.name" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="profile_data.risk">
                            <div class="profile-products-section" *ngFor="let opp of profile_data.retention_opp">
                                <div class="each-profile-product-section each-profile-product-inactive">
                                    <div class="each-profile-product-heading-section">
                                        <span>Risk</span>
                                    </div>
                                    <div class="each-profile-product-details-section">
                                        <div class="each-profile-product-aum-section">
                                            <p class="each-profile-product-aum-label">Actual Loss({{APP_CONSTANTS.CURRENCY_SYMBOL}})</p>
                                            <p class="each-profile-product-aum-value">{{opp.actual_loss}}</p>
                                        </div>
                                        <div class="each-profile-product-aum-section">
                                            <p class="each-profile-product-aum-label">Predicted Estimated Loss({{APP_CONSTANTS.CURRENCY_SYMBOL}})</p>
                                            <p class="each-profile-product-aum-value">{{opp.predicted_overall_loss}}</p>
                                        </div>
                                        <div class="each-profile-product-aum-section">
                                            <p class="each-profile-product-aum-label">Predicted Closure Days</p>
                                            <p class="each-profile-product-aum-value">{{opp.predicted_closure_days}}</p>
                                        </div>
                                    </div>
                                    <div class="each-profile-product-sub-details-section">
                                        <div class="each-product-detail-section">
                                            <span class="each-product-detail-label">Trigger Type</span>
                                            <span class="each-product-detail-value">{{opp.trigger_type}}</span>
                                        </div>
                                        <div class="each-product-detail-section">
                                            <span class="each-product-detail-label">Trigger</span>
                                            <span class="each-product-detail-value">{{opp.trigger}}</span>
                                        </div>
                                        <div class="each-product-detail-section">
                                            <span class="each-product-detail-label">Condition</span>
                                            <span class="each-product-detail-value">{{opp.reason}}</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="profile-opp-reco-section">
                                    <div class="profile-opp-stages-section">
                                        <p class="profile-opp-stages-heading">Sales Process</p>
                                        <div class="each-profile-opp-stage" *ngFor="let stage of opp.stages" [ngClass]="{'each-profile-opp-stage-selected': stage.line}">
                                            <div class="each-profile-opp-stage-details-section">
                                                <div class="each-profile-opp-circle-section" [ngClass]="{'each-profile-opp-circle-selected': stage.is_completed}"></div>
                                                <span class="each-profile-opp-circle-name">{{stage.name}}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="profile-opp-section">
                                        <!-- <div class="profile-opp-recomendation-section">
                                            <p class="profile-opp-recomendation-heading">Recommended Products</p>
                                            <p class="profile-opp-stages-heading">Recommended Products</p>
                                            <p class="profile-opp-recomendation-value" *ngFor="let recommended_product of opp.recommended_products">&#x2022; {{recommended_product}}</p>
                                        </div> -->

                                        <div class="profile-opp-recomendation-section">
                                            <!-- <p class="profile-opp-recomendation-heading">Preferred channels</p> -->
                                            <p class="profile-opp-stages-heading">Preferred channels</p>
                                            <div class="each-profile-channel-section">
                                                <img [src]="preffered_channel.image_link" class="each-profile-channel-image" *ngFor="let preffered_channel of opp.preferred_channel" [matTooltip]="preffered_channel.name" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="profile_data.client_engagement">
                            <div class="profile-products-section" *ngFor="let opp of profile_data.enagagement_opp">
                                <div class="each-profile-product-section each-profile-product-medium-active">
                                    <div class="each-profile-product-heading-section">
                                        <!-- <span>AI Advisor Assistant</span> -->
                                        <span>MAGI</span>
                                    </div>
                                    <div class="each-profile-product-details-section">
                                        <div class="each-profile-product-aum-section">
                                            <p class="each-profile-product-aum-label">Total engagements till date</p>
                                            <p class="each-profile-product-aum-value">{{opp.total_engagements}}</p>
                                        </div>
                                    </div>
                                    <div class="each-profile-product-sub-details-section">
                                        <div class="each-product-detail-section">
                                            <span class="each-product-detail-label">Trigger Type</span>
                                            <span class="each-product-detail-value">{{opp.trigger_type}}</span>
                                        </div>
                                        <div class="each-product-detail-section">
                                            <span class="each-product-detail-label">Trigger</span>
                                            <span class="each-product-detail-value">{{opp.trigger}}</span>
                                        </div>
                                        <div class="each-product-detail-section">
                                            <span class="each-product-detail-label">Condition</span>
                                            <span class="each-product-detail-value">{{opp.reason}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="!profile_data.growth_opportunity && !profile_data.risk && !profile_data.client_engagement">
                            <div class="each-product-zero-section">
                                <span class="each-profile-product-aum-value">No Data Found</span>
                            </div>
                        </ng-container>
                    </ng-container>

                    <ng-container *ngIf="profile_tab_selected == profile_tabs[3].name">
                        <div class="profile-products-section"*ngIf="profile_data.beneficiaries.length > 0">
                            <div class="each-profile-product-section" *ngFor="let beneficiary of profile_data.beneficiaries" [ngClass]="{'each-profile-product-active': beneficiary.is_primary}">
                                <div class="each-profile-product-heading-section">
                                    <span>{{beneficiary.first_name}} {{beneficiary.last_name}}</span>
                                    <span class="each-profile-product-active-tag" *ngIf="beneficiary.is_primary">Primary</span>
                                </div>
                                <div class="each-profile-product-details-section">
                                    <div class="each-profile-product-aum-section">
                                        <p class="each-profile-product-aum-label">Allocation (%)</p>
                                        <p class="each-profile-product-aum-value">{{beneficiary.percentage_allocation}}</p>
                                    </div>
                                    <div class="each-product-detail-section">
                                        <span class="each-product-detail-label">Email</span>
                                        <span class="each-product-detail-value">{{beneficiary.email}}</span>
                                    </div>
                                    <div class="each-product-detail-section">
                                        <span class="each-product-detail-label">Date of Birth</span>
                                        <span class="each-product-detail-value" *ngIf="beneficiary.birth_date != '' && beneficiary.birth_date != null">{{ beneficiary.birth_date | date: "dd MMM yyyy" }}</span>
                                        <span class="each-product-detail-value" *ngIf="beneficiary.birth_date == '' || beneficiary.birth_date == null" >-</span>
                                    </div>
                                    <div class="each-product-detail-section">
                                        <span class="each-product-detail-label">Relationship</span>
                                        <span class="each-product-detail-value">{{beneficiary.relationship_type_name}}</span>
                                    </div>
                                    <div class="each-product-detail-section">
                                        <span class="each-product-detail-label">Gender</span>
                                        <span class="each-product-detail-value">{{beneficiary.gender_name}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ng-container *ngIf="profile_data.beneficiaries.length == 0">
                            <div class="each-product-zero-section">
                                <span class="each-profile-product-aum-value">No Data Found</span>
                            </div>
                        </ng-container>
                    </ng-container>

                    <ng-container *ngIf="profile_tab_selected == profile_tabs[4].name">
                        <div class="profile-products-section" *ngIf="profile_data.client_goals.length > 0">
                            <div class="each-profile-product-section each-profile-product-active" *ngFor="let client_goal of profile_data.client_goals" [ngClass]="{'each-profile-product-active': client_goal.risk_tolerance == 'Low', 'each-profile-product-medium-active': client_goal.risk_tolerance == 'Medium', 'each-profile-product-inactive': client_goal.risk_tolerance == 'High'}">
                                <div class="each-profile-product-heading-section">
                                    <span>{{client_goal.investment_purpose}}</span>
                                    <span class="each-profile-product-active-tag" *ngIf="client_goal.risk_tolerance == 'Low'">{{client_goal.risk_tolerance}}</span>
                                    <span class="each-profile-product-medium-tag" *ngIf="client_goal.risk_tolerance == 'Medium'">{{client_goal.risk_tolerance}}</span>
                                    <span class="each-profile-product-inactive-tag" *ngIf="client_goal.risk_tolerance == 'High'">{{client_goal.risk_tolerance}}</span>
                                </div>
                                <div class="each-profile-product-details-section">
                                    <div class="each-profile-product-aum-section">
                                        <p class="each-profile-product-aum-label">Target Amount ({{APP_CONSTANTS.CURRENCY_SYMBOL}})</p>
                                        <p class="each-profile-product-aum-value">{{client_goal.target_amount}}</p>
                                    </div>
                                    <div class="each-product-detail-section">
                                        <span class="each-product-detail-label">Accomplished Target({{APP_CONSTANTS.CURRENCY_SYMBOL}})</span>
                                        <span class="each-product-detail-value">{{client_goal.accomplished_target}}</span>
                                    </div>
                                    <div class="each-product-detail-section">
                                        <span class="each-product-detail-label">Investment Goal Tenure</span>
                                        <span class="each-product-detail-value">{{client_goal.investment_goal_tenure}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ng-container *ngIf="profile_data.client_goals.length == 0">
                            <div class="each-product-zero-section">
                                <span class="each-profile-product-aum-value">No Data Found</span>
                            </div>
                        </ng-container>
                    </ng-container>

                    <ng-container *ngIf="profile_tab_selected == profile_tabs[5].name">
                        <div class="profile-products-section"*ngIf="profile_data.trusted_contact.length > 0">
                            <div class="each-profile-product-section" *ngFor="let trustedcontact of profile_data.trusted_contact">
                                <div class="each-profile-product-heading-section">
                                    <span>{{trustedcontact.first_name}} {{trustedcontact.last_name}}</span>
                                </div>
                                <div class="each-profile-product-details-section">
                                    <div class="each-product-detail-section">
                                        <span class="each-product-detail-label">Email</span>
                                        <span class="each-product-detail-value">{{trustedcontact.email}}</span>
                                    </div>
                                    <div class="each-product-detail-section">
                                        <span class="each-product-detail-label">Phone Number</span>
                                        <span class="each-product-detail-value">{{trustedcontact.telephone_number}}</span>
                                    </div>
                                    <div class="each-product-detail-section">
                                        <span class="each-product-detail-label">Date of Birth</span>
                                        <span class="each-product-detail-value" *ngIf="trustedcontact.birth_date != '' && trustedcontact.birth_date != null">{{ trustedcontact.birth_date | date: "dd MMM yyyy" }}</span>
                                        <span class="each-product-detail-value" *ngIf="trustedcontact.birth_date == '' || trustedcontact.birth_date == null" >-</span>
                                    </div>
                                    <div class="each-product-detail-section">
                                        <span class="each-product-detail-label">Relationship</span>
                                        <span class="each-product-detail-value">{{trustedcontact.relationship_type_name}}</span>
                                    </div>
                                    <div class="each-product-detail-section">
                                        <span class="each-product-detail-label">Gender</span>
                                        <span class="each-product-detail-value">{{trustedcontact.gender_name}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ng-container *ngIf="profile_data.trusted_contact.length == 0">
                            <div class="each-product-zero-section">
                                <span class="each-profile-product-aum-value">No Data Found</span>
                            </div>
                        </ng-container>
                    </ng-container>
                </ng-container>


            </ng-container>
            <ng-container *ngIf="!profile_data_loaded">
                <app-loader [loading_text]="'Loading Client Data'"></app-loader>
            </ng-container>
        </div>
    </div>
</div>
